import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const styles = (theme) => {
	return {
		innerPaper: {
			padding: 10,
			paddingTop: 5,
			textAlign: 'left',
			fontSize: 14,
			[theme.breakpoints.up('md')]: {
				padding: 40,
				paddingTop: 30,
			}
		},
	};
};

class BillingDashboard extends Component {
	render () {
		const {
			classes,
		} = this.props;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12} md={6}>
					<Paper>
						<div className={classes.innerPaper}>
							<Typography variant="h5" align="left" gutterBottom style={{position:'relative'}}>
								Billing Dashboard
							</Typography>
							<div>
								Future stats and graphs here....
							</div>
						</div>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

BillingDashboard.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
])(BillingDashboard);
